const TestimonialsSection = () => {
  const staticReviews = [
    {
      author: "Sarah Mitchell",
      rating: 5,
      text: "Absolutely loved our stay at Dunn's O.V.! The rooms were spotless, the staff was incredibly friendly, and the pub food was outstanding. The ocean view from our room was breathtaking. Can't wait to come back!",
      relativeTime: "2 weeks ago"
    },
    {
      author: "James Rodriguez",
      rating: 5,
      text: "Best sports pub in the area! Great atmosphere, cold beer, and the wings are phenomenal. The staff really knows how to make you feel at home. Perfect spot to catch the game with friends.",
      relativeTime: "1 month ago"
    },
    {
      author: "Emily Chen",
      rating: 5,
      text: "We had our family reunion here and it was perfect. The accommodations were comfortable, the menu had something for everyone, and the location is unbeatable. The Thursday steak night is a must-try!",
      relativeTime: "3 weeks ago"
    },
    {
      author: "Michael Thompson",
      rating: 5,
      text: "Great value for money! Clean rooms, friendly service, and excellent food. The pub has a fantastic selection of beers and the burgers are some of the best I've had. Highly recommend!",
      relativeTime: "1 week ago"
    },
    {
      author: "Lisa Anderson",
      rating: 5,
      text: "Perfect getaway spot! The inn is charming, the pub is lively, and the staff goes above and beyond. We especially loved the seafood baskets - so fresh and delicious. Will definitely be back!",
      relativeTime: "2 months ago"
    },
    {
      author: "David Park",
      rating: 5,
      text: "Outstanding experience from start to finish. The rooms are well-maintained, the pub has a great vibe, and the food quality is top-notch. The location is perfect for exploring the area. Five stars!",
      relativeTime: "3 weeks ago"
    }
  ];

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 font-serif">
            What Our Guests Say
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Real 5-star reviews from our happy guests
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {staticReviews.map((review, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed mb-6 italic line-clamp-6">
                "{review.text}"
              </p>
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-600 to-cyan-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-sm">
                    {getInitials(review.author)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-slate-900">{review.author}</p>
                  <p className="text-sm text-slate-600">{review.relativeTime}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://www.google.com/maps/search/?api=1&query=Dunn's+O.V.+OceanView+Inn+%26+Sports+Pub"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-full font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            <i className="ri-google-fill text-2xl"></i>
            <span>Read All Reviews on Google</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
